import React from "react"
import DefaultLayout from "../../components/layout/DefaultLayout"
import { Row, Col, Button, Container } from "react-bootstrap"
import { EnrolmentForm } from "../../components/enrolment-form/EnrolmentForm"
import { EnrolmentTable } from "../../components/enrolment-table/EnrolmentTable"
import { Link, useParams } from "react-router-dom"

const Enrollment = () => {
  const { add } = useParams()

  return (
    <DefaultLayout>
      <Container>
        {add ? (
          <EnrolmentForm />
        ) : (
          <div className="">
            <Row className="py-2">
              <Col>
                <h5>Enrolment</h5>
                <div className="text-end">
                  <Link to="/enrol/add">
                    <Button variant="primary">Start New Enrolment</Button>
                  </Link>
                </div>
                <hr />
              </Col>
            </Row>
            <Row>
              <Col>
                <EnrolmentTable />
              </Col>
            </Row>
          </div>
        )}
      </Container>
    </DefaultLayout>
  )
}

export default Enrollment
